export enum SettingKeyType {
  CHECKBOX = 'checkbox',
  SELECT = 'select',
  NUMBER = 'number',
  TEXT = 'text',
  TEXTAREA = 'textarea',
  DATE = 'date',
  TIME = 'time',
  DATETIME = 'datetime',
  EMAIL = 'email',
  URL = 'url',
  COLOR = 'color',
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
}

export enum SettingScope {
  COMPANY = 'company',
  CORPORATE_COMPANY = 'corporate_company',
  FLEET_COMPANY = 'fleet_company',
  USER = 'user',
  ADMIN_USER = 'admin_user',
  CAR = 'car',
  DRIVER = 'driver',
  CLIENT = 'client',
  EMPLOYEE = 'employee',
  SYSTEM = 'system',
}

export interface SettingKey {
  id: number;
  keyName: string;
  slug: string;
  description?: string;
  keyType: SettingKeyType;
  scope: SettingScope;
  options?: string[] | { value: string; label: string }[];
  defaultValue?: string;
  validationRules?: string;
  isActive: boolean;
  isRequired: boolean;
  isReadonlyForChild?: boolean;
  sortOrder: number;
  groupName?: string;
  unit?: string;
  createdAt: Date;
  updatedAt: Date;
}
